import { Models } from '@ibexfusion/models';
import * as _ from 'lodash';

import { RestProvider } from './rest.service';
import { DataProvider, DataProviderResponse } from '../data-provider';

export abstract class RestfulService<T extends Models.IbexBaseModel> implements DataProvider<T> {

  private provider: RestProvider;

  constructor(private TCreator?: new () => T) {
  }

  public init(): void {
    this.provider = this.createProvider();
  }

  public abstract createProvider(): RestProvider;

  public find(skip: number, limit: number, params?: any): Promise<DataProviderResponse<T>> {
    let query = _.merge({ $skip: skip, $limit: limit }, params);

    return this.provider.find({
      query: query
    }).then(rawData => {
      if (!rawData || !rawData.data) {
        return { data: [], limit: 0, skip: 0, total: 0 };
      }
      let data: T[] = [];

      if ((this.provider.endpointName === 'daily-analytic-logs' || this.provider.endpointName === 'daily-analytic-log-by-timestamps') && params.options) {
        data = rawData.data;
      } else {
        for (let i = 0; i < rawData.data.length; i++) {
          const newItem = new this.TCreator();
          newItem.populateFromJSON(rawData.data[i]);
          data.push(newItem);
        }
      }

      const response: DataProviderResponse<T> = {
        data, limit: rawData.limit, skip: rawData.skip, total: rawData.total, translations: rawData.translations, children: rawData.children
      };

      return response;
    });
  }

  public get(id: string, params?: any): Promise<T> {
    return this.provider.get(id, params).then(rawData => {
      const newItem = new this.TCreator();
      newItem.populateFromJSON(rawData);

      return newItem;
    });
  }

  public remove(id: string): Promise<boolean> {
    return this.provider.remove(id);
  }

  public create(data: any, params?: any): Promise<T> {
    if (data.toJSON) {
      data = data.toJSON();
    }
    return this.provider.create(data, params).then(rawData => {
      const newItem = new this.TCreator();
      newItem.populateFromJSON(rawData);

      return newItem;
    });
  }

  public update(id: string, data: any, params?: any): Promise<T> {
    if (data.toJSON) {
      data = data.toJSON();
    }
    return this.provider.update(id, data, params).then(rawData => {
      const newItem = new this.TCreator();
      newItem.populateFromJSON(rawData);

      return newItem;
    });
  }

  public patch(id: string, data: any, params?: any): Promise<T> {
    return this.provider.patch(id, data, params).then(rawData => {
      const newItem = new this.TCreator();
      newItem.populateFromJSON(rawData);

      return newItem;
    });
  }

}
